import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

const BannersFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
    </Filter>
  )
}

export const ListBanners: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<BannersFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" sortable={false} />
        <TextField label="Título" source="title" sortable={false} />
        <TextField label="Slug" source="slug" sortable={false} />
      </Datagrid>
    </List>
  )
}
